import React from "react";
import PropTypes from 'prop-types';

/*
 ** Loading => gentle fade in/out animated shape for loading
 */

const Loading = ({color}) => {
	
	// add colors to helper stylesheet as needed. Default is white
	return (
		<div
			className={color? `loading--${color}` : `loading`}
			aria-label="loading/chargement-en-cours"
		>
			<div className="lds-dual-ring"></div>
		</div>
	);
};
Loading.propTypes = {
	color: PropTypes.any
};


export default Loading;